

export const updateLocomotiveModals = () => {
  const wrapper = document.getElementById("glo-modals")
  // clear wrapper
  wrapper.innerHTML = "";
  // get all modals
  const listModals = [...document.querySelectorAll(".modal")]
  listModals.forEach((el, index) => {
    wrapper.appendChild(el)
  })
  
}